window.mobileMenu = function mobileMenu() {

    var menu_wrap,
        menu_wrap_height = 0,
        dropdown_height = 0,
        initial_menu_wrap_height = 0,
        sub_menu_height = 0,
        flyout_menu = $('.flyoutMenu'),
        menu_inner_wrap,
        menu_inner_height = 0;

    if ($('.franchiseMenuWrapper').length) {
        menu_wrap = $('.franchiseMenuWrapper .mainNavigation');
        menu_inner_wrap = $('.franchiseMenuWrapper .mainNavigation .mainNavInnerWrap');
    } else {
        menu_wrap = $('.mainMenuWrapper .mainNavigation');
        menu_inner_wrap = $('.mainMenuWrapper .mainNavigation .mainNavInnerWrap');
    }

    if ($('.mainMenuWrapper').length === 0) {
        menu_wrap = $('.mainNavigation');
        menu_inner_wrap = $('.mainNavigation .mainNavInnerWrap');
    }

    $('.js_menuFlyoutButton').on('click', function (e) {

        if (windowWidth <= 1024) {
            e.preventDefault();

            $(this).toggleClass('open');
            $('body').toggleClass('menuFlyoutActive');

            // close search
            if ($('.js_keywordSearchToggleBtn').hasClass('open')) {
                $('.js_keywordSearchToggleBtn').removeClass('open');
                $('.js_keywordSearchWrap').fadeOut();
            }

            /*menu_wrap.slideFadeToggle(function () {
                menu_wrap_height = menu_wrap.innerHeight();
                menu_inner_height = menu_inner_wrap.innerHeight();
            });*/

            menu_wrap_height = menu_wrap.innerHeight();
            menu_inner_height = menu_inner_wrap.innerHeight();
        } else {
            flyout_menu.toggleClass("active");
            // $(".flyoutMenu").perfectScrollbar();
        }
    });

    // sub menus, one level deep (most of them)
    $('.mainNavigation .hasChildren > a:not(.dropdownLink)').on('click', function (e) {

        if (windowWidth <= 1024) {

            if ($(this).attr('href') !== '/electric-cars' ||
                !$(this).attr('href').includes("/finance-and-offers") ||
                !$(this).attr('href').includes("/service-and-mot")) {
                e.preventDefault();

                lazyLoadedImages.update()

                $(this).parent().addClass('subMenuOpen');

                sub_menu_height = $(this).next('.dropdownWrap').outerHeight();

                // menu_wrap.stop().animate({
                //     height: sub_menu_height
                // });

                menu_inner_wrap.stop().animate({
                    height: sub_menu_height
                });
            }
        }
    });

    // back link, undoes what the above does
    $('.js_subMenuBackLink').on('click', function (e) {
        if (windowWidth <= window.breakpoints.mobile) {
            e.preventDefault();

            if ($(this).parents('.dropdownSubMenu').length) {
                // this handles it if it's 3 levels deep
                $(this).parents('.dropdownSubMenu').removeClass('subMenuOpen');

                // menu_wrap.stop().animate({
                //     height: sub_menu_height
                // });

                menu_inner_wrap.stop().animate({
                    height: sub_menu_height
                });

                return;
            }

            // default functionality
            $(this).parents('.hasChildren').removeClass('subMenuOpen');

            // menu_wrap.stop().animate({
            //     height: menu_wrap_height
            // });

            menu_inner_wrap.stop().animate({
                height: menu_inner_height
            });
        }
    });

    // this handles menus 3 levels deep at mobile, at the moment, only shop does this
    $('.js_hasASubMenu li:not(.js_hasNoSubMenu').on('click', function (e) {
        if (windowWidth <= window.breakpoints.mobile) {
            e.preventDefault();
            console.log('clicked submenu');

            var $this = $(this),
                index = $this.index();

            var menu = $this.closest('.hasChildren');
            var menu_list = menu.find('.menuList');
            var submenus = menu.find('.dropdownSubMenu');
            var sub_menu_height = menu_list.eq(index).outerHeight();

            lazyLoadedImages.update();

            submenus.toggleClass('subMenuOpen');

            $this.siblings().removeClass('active');
            $this.addClass('active');

            menu_list.removeClass('active fade');
            menu_list.eq(index).addClass('active fade');

            // menu_wrap.stop().animate({
            //     height: sub_menu_height
            // });

            menu_inner_wrap.stop().animate({
                height: sub_menu_height
            });
        }
    });

    var subMenu = $(".js_toggleSubmenu");

    if (subMenu.length > 0) {
        subMenu.click(function() {
            $(this).next().stop().slideToggle();
        });
    }
}

$(document).ready(function () {
    'use strict';

    mobileMenu();
});

$(window).on('resize', debouncer(function (e) {

    'use strict';

    if (windowWidth > window.breakpoints.mobile) {
        $('.mainNavigation').removeAttr('style');
        $('.mainNavigation .mainNavInnerWrap').removeAttr('style');
    }

})); // window resize
